module.exports = __webpack_public_path__ + "img/gin_1.4657ab00.gif";